import { CheckCircleFilled } from "@ant-design/icons";
import { Tooltip } from "antd";
import dayjs from "dayjs";
import styles from "./notes.module.scss";

type Props = {
  transferredAt: string;
};

// Marks a note tile once the note has been written to the EHR, so nobody transfers it twice.
// `focus` is in the trigger list so the date is reachable by keyboard, not just hover.
export default function TransferredPill({ transferredAt }: Props) {
  const label = `Transferred to EHR on ${dayjs(transferredAt).format("MMM D, YYYY, h:mm A")}`;

  return (
    <Tooltip title={label} trigger={["hover", "focus"]}>
      <span className={styles["notes__transferred-pill"]} tabIndex={0} role="note" aria-label={label}>
        <CheckCircleFilled />
        Transferred
      </span>
    </Tooltip>
  );
}
